import { useDispatch } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { contractorsActions } from "../../../../_store/contractors.slice";
import { SelectSearcher } from "../../../../_components/Abstractions/MultiSearcher/SelectSearcher";

export function WastesKindsSelect({ name, label, required = true, isUsedContainerRequired = false, isAddressIdRequired = false, usedContainerId, addressId, transactionType, skipInitLoading = false, includeAllWasteKinds }) {
  const dispatch = useDispatch();
  const isFirstRender = useRef(true);
  const [items, setItems] = useState([]);

  const onSearchChange = async (searchTerm) => {
    if (isUsedContainerRequired && !usedContainerId) {
      setItems([]);
      return;
    }

    const params = { searchQuery: searchTerm, usedContainerId, addressId, transactionType, includeAllWasteKinds };
    const response = await dispatch(contractorsActions.searchUsedWastes({ payload: params }));
    setItems(response.payload ?? []);
  };

  useEffect(() => {
    if (isFirstRender.current && skipInitLoading) {
      isFirstRender.current = false;
      return;
    }
    onSearchChange(null);
  }, [addressId, usedContainerId]); // eslint-disable-next-line/react-hooks/exhaustive-deps

  return (
    <SelectSearcher
      name={name}
      items={items}
      onSearchChange={onSearchChange}
      optionsObject={{ key: "wasteEntityId", value: "displayDescription" }}
      label={label ?? "Wybierz towar (gatunek)"}
      required={required}
      readonly={(isUsedContainerRequired && !usedContainerId) || (isAddressIdRequired && !addressId)}
      saveWholeObject
    />
  );
}
